import { Events } from "@Context/common/general/context";
import { Box, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

interface ICountdownProps {
  count?: number;
  onComplete?: () => void;
}

export default function Countdown({ count = 5, onComplete = () => {} }: ICountdownProps) {
  const theme = useTheme();
  const [time, setTime] = useState(count);

  useEffect(() => {
    Events.audio.playSound.emit({ src: "countdown_start", volume: 1 });
    const interval = setInterval(() => {
      setTime(time => {
        if (time <= 0) {
          onComplete();
          clearInterval(interval);
        } else {
          Events.audio.playSound.emit({ src: "countdown_tick", volume: 1 });
        }
        return time - 1 >= 0 ? time - 1 : 0;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: theme.spacing(20),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontSize: `clamp(${theme.spacing(18)}, 18vw, ${theme.spacing(28)})`,
          fontWeight: 800,
          lineHeight: 0.9,
          letterSpacing: "-0.04em",
          boxSizing: "border-box",
          width: "100%",
          color: theme.palette.dsBase.v200,
        }}
      >
        {time}
      </Typography>
    </Box>
  );
}
